/* eslint-disable */
export const step = Object.freeze({
  SERVICE_STARTED: {
    'event': 'crossfunel',
    'etapaNome': 'atendimento',
    'etapaEstado': 'iniciada',
  },
  SERVICE_COMPLETED: {
    'event': 'crossfunel',
    'etapaNome': 'atendimento',
    'etapaEstado': 'finalizada',
  },

  QUESTIONS_STARTED: {
    'event': 'crossfunel',
    'etapaNome': 'questoes',
    'etapaEstado': 'iniciada',
  },
  QUESTIONS_COMPLETED: {
    'event': 'crossfunel',
    'etapaNome': 'questoes',
    'etapaEstado': 'finalizada',
  },

  EXAMS_STARTED: {
    'event': 'crossfunel',
    'etapaNome': 'exams',
    'etapaEstado': 'iniciada',
  },
  EXAMS_COMPLETED: {
    'event': 'crossfunel',
    'etapaNome': 'exams',
    'etapaEstado': 'finalizada',
  },

  PAYMENT_CHOICE_STARTED: {
    'event': 'crossfunel',
    'etapaNome': 'escolhaPagamento',
    'etapaEstado': 'iniciada',
  },
  PAYMENT_CHOICE_COMPLETED: {
    'event': 'crossfunel',
    'etapaNome': 'escolhaPagamento',
    'etapaEstado': 'finalizada',
  },
});

export const serviceDesk = Object.freeze({
  EXCLUSIVE: {
    'event': 'finalizar-guiche',
    'finalizacaoTipo': 'exclusivo',
  },
  GET_TICKET: {
    'event': 'finalizar-guiche',
    'finalizacaoTipo': 'tirar-senha',
  },
});
/* eslint-enable */
